import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationDialog from '../../../shared/components/ConfirmationDialog/ConfirmationDialog';

export default class RemoveFromBlacklistDialog extends React.Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    email: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  };

  render() {
    const { open, email, onClose, onConfirm } = this.props;

    return (
      <ConfirmationDialog
        isOpen={open}
        dialogTitle="Remove from blacklist"
        dialogContent={`Are you sure you want to remove "${email}" from the blacklist?`}
        confirmButtonText="Remove"
        cancelButtonText="Cancel"
        onConfirm={onConfirm}
        onClose={onClose}
        onCancel={onClose}
      />
    );
  }
}
